import React from 'react';
import { Link } from 'react-router-dom';
import { contactDetails, contactHours, contactTopics } from '../data/siteContent';
import { PageHero } from '../components/PageHero';
import { EnquiryForm } from '../components/EnquiryForm';
export function Contact() {
  return <div className="w-full bg-paper" data-id="element-352" data-mp="1lqa0fh2x7zyp">
      <PageHero eyebrow="Contact" title="Talk to us." intro="One form, one inbox, one working day. No ticket numbers." data-id="element-353" data-mp="1lrbfdwn256lp" />

      <section className="mx-auto max-w-[1400px] px-6 pb-28 pt-8 md:pt-16" data-id="element-354" data-mp="xycsw26i7u3e">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr] lg:gap-20" data-id="element-355" data-mp="t3fiorxhneox">
          {/* Details */}
          <div data-id="element-356" data-mp="17rtkr0n2yz4f">
            <p className="type-eyebrow mb-6 text-[10px] text-pennant" data-id="element-357" data-mp="17sbqqozjorpj">
              Direct
            </p>
            <ul className="space-y-6" data-id="element-358" data-mp="fa7pwwxo8d5n">
              {contactDetails.map(d => <li key={d.label} className="border-b border-oat/60 pb-5" data-id="element-359" data-mp="f7uzrwhrewhi">
                  <p className="type-eyebrow mb-2 text-[9px] text-coffee/45" data-id="element-360" data-mp="aalcamdxkuwb">
                    {d.label}
                  </p>
                  <p className="type-ui text-base text-coffee" data-id="element-361" data-mp="15dm4d1acop85">{d.value}</p>
                </li>)}
            </ul>

            <p className="type-eyebrow mb-5 mt-12 text-[10px] text-pennant" data-id="element-362" data-mp="1e78qs0so4g4o">
              Hours
            </p>
            <ul className="space-y-3" data-id="element-363" data-mp="1j5sadujshftv">
              {contactHours.map(h => <li key={h.day} className="flex justify-between gap-6" data-id="element-364" data-mp="mh2qxzsikf5s">
                  <span className="type-body text-sm text-ink/65" data-id="element-365" data-mp="qi68qru4gl9n">
                    {h.day}
                  </span>
                  <span className="type-ui text-sm text-coffee" data-id="element-366" data-mp="vgpwmxsa074n">
                    {h.hours}
                  </span>
                </li>)}
            </ul>

            <div className="mt-12 rounded-3xl bg-paper-warm p-8" data-id="element-367" data-mp="10dzjq6s706pb">
              <p className="type-body text-sm text-ink/65" data-id="element-368" data-mp="26vwe01wz9fkv">
                Looking for care instructions, delivery times or returns? Most
                answers are already on the{' '}
                <Link to="/faqs" className="text-coffee underline underline-offset-4" data-id="element-369" data-mp="1m627xe1827os">
                  FAQs
                </Link>{' '}
                page.
              </p>
            </div>
          </div>

          {/* Form */}
          <div data-id="element-370" data-mp="1r66nn1ub2ydy">
            <p className="type-eyebrow mb-6 text-[10px] text-pennant" data-id="element-371" data-mp="1r7rkwz808vfi">
              Send a message
            </p>
            <EnquiryForm submitLabel="Send message" note="We reply within one working day." fields={[{
            name: 'name',
            label: 'Name',
            half: true,
            required: true
          }, {
            name: 'email',
            label: 'Email',
            type: 'email',
            half: true,
            required: true
          }, {
            name: 'topic',
            label: 'What is this about?',
            type: 'select',
            options: contactTopics,
            required: true
          }, {
            name: 'order',
            label: 'Order number (if you have one)',
            half: true
          }, {
            name: 'phone',
            label: 'Phone (optional)',
            type: 'tel',
            half: true
          }, {
            name: 'message',
            label: 'Message',
            type: 'textarea',
            required: true
          }]} data-id="element-372" data-mp="13h5c35q6f74g" />
          </div>
        </div>
      </section>
    </div>;
}